import React from 'react';
import { Select, Input, RadioGroup, RadioButton, Card } from 'components';
import { CreateListingCardProps, FinancialsFields } from '../types';
import { StyledGrid } from './StyledComponents';

type FinancialsProps = CreateListingCardProps<FinancialsFields>;

const Financials: React.FC<FinancialsProps> = ({
  financials: {
    taxes,
    gross_income,
    insurance,
    vacancy_allowance,
    management,
    operating_expenses,
    maintenance,
    net_income,
    heat,
    expenses,
    hydro,
    year_expenses,
    water,
    cap_rate,
    available,
  },
  setListing,
}) => {
  const handleChange = (changes: Partial<FinancialsProps['financials']>) => {
    setListing(prev => ({
      ...prev,
      financials: { ...prev.financials, ...changes },
    }));
  };

  return (
    <Card type="primary" title="Financials" id="financials">
      <StyledGrid $columns={3}>
        <Input
          label="Taxes"
          value={taxes}
          onChange={({ target: { value } }) => handleChange({ taxes: value })}
          data-cy="listing-financials-taxes"
        />
        <Input
          label="Gross Income/Sales"
          value={gross_income}
          onChange={({ target: { value } }) =>
            handleChange({ gross_income: value })
          }
          data-cy="listing-financials-gross-income"
        />
        <Input
          label="Insurance"
          value={insurance}
          onChange={({ target: { value } }) =>
            handleChange({ insurance: value })
          }
          data-cy="listing-financials-insurance"
        />
        <Input
          label="Vacancy Allowance"
          value={vacancy_allowance}
          onChange={({ target: { value } }) =>
            handleChange({ vacancy_allowance: value })
          }
          data-cy="listing-financials-vacancy-allowance"
        />
        <Input
          label="Management"
          value={management}
          onChange={({ target: { value } }) =>
            handleChange({ management: value })
          }
          data-cy="listing-financials-management"
        />
        <Input
          label="Operating Expenses"
          value={operating_expenses}
          onChange={({ target: { value } }) =>
            handleChange({ operating_expenses: value })
          }
          data-cy="listing-financials-operating-expenses"
        />
        <Input
          label="Maintenance"
          value={maintenance}
          onChange={({ target: { value } }) =>
            handleChange({ maintenance: value })
          }
          data-cy="listing-financials-maintenance"
        />
        <Input
          label="Net Income"
          value={net_income}
          onChange={({ target: { value } }) =>
            handleChange({ net_income: value })
          }
          data-cy="listing-financials-net-income"
        />
        <Input
          label="Heat"
          value={heat}
          onChange={({ target: { value } }) => handleChange({ heat: value })}
          data-cy="listing-financials-heat"
        />
        <Select
          allowClear
          label="Expenses"
          value={expenses}
          onChange={value => handleChange({ expenses: value })}
          options={[
            { label: 'Actual', value: 'Actual' },
            { label: 'Estimated', value: 'Estimated' },
          ]}
          data-cy="listing-financials-expenses"
        />
        <Input
          label="Hydro"
          value={hydro}
          onChange={({ target: { value } }) => handleChange({ hydro: value })}
          data-cy="listing-financials-hydro"
        />
        <Input
          label="Year Expenses"
          value={year_expenses}
          onChange={({ target: { value } }) =>
            handleChange({ year_expenses: value })
          }
          data-cy="listing-financials-year-expenses"
        />
        <Input
          label="Water"
          value={water}
          onChange={({ target: { value } }) => handleChange({ water: value })}
          data-cy="listing-financials-water"
        />
        <Input
          label="Cap Rate (%)"
          value={cap_rate}
          onChange={({ target: { value } }) =>
            handleChange({ cap_rate: value })
          }
          data-cy="listing-financials-cap-rate"
        />
        <RadioGroup
          allowClear
          label="Financials Avail"
          buttonStyle="solid"
          value={available}
          onChange={({ target: { value } }) =>
            handleChange({ available: value })
          }
          data-cy="listing-financials-avail"
        >
          <RadioButton value="No">No</RadioButton>
          <RadioButton value="Yes">Yes</RadioButton>
        </RadioGroup>
      </StyledGrid>
    </Card>
  );
};

export default React.memo(Financials);
